import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-white">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-secondary/5 z-0"></div>
      <div className="container-custom relative z-10 py-16 sm:py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="animate-slide-up">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl mb-6">
              Grow Your Financial Advisory Practice
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-2xl">
              Introducing an AI-powered marketing platform designed specifically for financial advisors—streamlining high quality lead generation, nurturing prospects, and enhancing client engagement through automation and personalization.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact" className="btn btn-primary">
                Get Started <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <Link to="/features" className="btn btn-outline">
                See How It Works
              </Link>
            </div>
          </div>
          <div className="relative lg:h-[500px] rounded-xl overflow-hidden shadow-2xl">
            <img
              src="https://images.pexels.com/photos/8867431/pexels-photo-8867431.jpeg"
              alt="Professional financial advisor consulting with diverse clients"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="bg-white bg-opacity-95 p-4 rounded-lg shadow-lg max-w-md">
                <div className="flex items-center gap-4 mb-2">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                    <span className="text-primary font-bold">100x</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Exponentially increase qualified leads</h3>
                    <p className="text-sm text-gray-600">Save thousands on marketing and business operations</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;